export interface EnumListItem {
    // reason: id data type is dynamic due to it is an enum
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    id: any;
    value: string;
}

export interface EnumOptionInterface {
    [key: string]: EnumOptionProperties;
}

export class EnumOptionProperties {
    label: string = '-';
    cssClass?: string = '';
    img?: string | null;
}

export interface UiProgramTypeInterface {
    [key: string]: UiProgramTypeProperties;
}

export class UiProgramTypeProperties {
    label: string = '-';
    backgroundColor = '';
    vectorCss = '';
}

export interface TabInfo<T> {
    tab: T;
    label: string;
}

export interface ListItem {
    id: number;
    value: string;
}

export interface SideMenuItem {
    link: string;
    title: string;
    icon: string;
    id?: string;
}

export class DropdownModel {
    value!: string | number;
    name!: string;
}

export class BooleanDropdownModel {
    value!: boolean | null;
    name!: string;
}

export interface SuccessPopupInterface {
    title: string;
    subText1: string;
    subText2?: string;
    closeButton: string;
    icon?: string;
}

export class SuccessPopupModel {
    title: string;
    subText1: string;
    subText2?: string;
    closeButton: string;
    icon: string;

    constructor(private model: SuccessPopupInterface) {
        this.title = model.title;
        this.subText1 = model.subText1;
        this.subText2 = model.subText2;
        this.closeButton = model.closeButton;
        this.icon = model.icon || 'bg-mark-success-lg-icon';
    }
}
